import { StringSystemType } from '@rover/kibble/core/styledSystemPropTypes';
import type { ThemeBackgroundColors } from '@rover/kibble/styles/themeTypes';
import type { RoverTheme } from '@rover/types/src/RoverTheme';

type CardStyleProps = {
  background?: ThemeBackgroundColors;
  border: StringSystemType;
  color?: string;
};

export type CardStyleOptions = 'default' | 'inset' | 'ledger';

const getCardStyle = (theme: RoverTheme, option: CardStyleOptions): CardStyleProps => {
  switch (option) {
    case 'default':
      return {
        background: 'primary',
        border: `1px solid ${theme.colors.border.primary}`,
      };
    case 'inset':
      return {
        background: 'secondary',
        border: '0 none',
      };
    case 'ledger':
      return {
        background: 'secondary',
        border: `1px solid ${theme.colors.border.primary}`,
        color: theme.textColor.secondary,
      };
    default:
      throw new Error(`Unknown card style option: ${option}`);
  }
};

export default getCardStyle;
